<script lang="ts" setup>
import { computed, watchEffect } from "vue"
import { isAuthorized } from "@/services/AuthService"
import { useStore } from "@/store/useStore"
import HomePage from "@/modules/home/HomePage.vue"
import LandingPage from "@/modules/landing/LandingPage.vue"

const authenticated = computed(isAuthorized)
const store = useStore()

// Hide sidebar on landing page, show it when authenticated
watchEffect(() => {
    if (!authenticated.value && store.sidebarShown) {
        store.toggleSidebar()
    } else if (authenticated.value && !store.sidebarShown) {
        store.toggleSidebar()
    }
})
</script>

<template lang="pug">
HomePage(v-if="authenticated")
LandingPage(v-else)
</template>
